module.exports = __webpack_public_path__ + "static/media/quote.7f882377.svg";